<div class="tickets-page">
  <!-- Sidebar -->
  <aside class="sidebar">
    <div class="sidebar-filter-box flex items-center justify-between">
      <h2 class="sidebar-title">All tickets</h2>
      <img src="/dashboard/tickets/1.svg" alt="" />
    </div>

    <button type="button" class="new-ticket-button">
      <i class="ri-add-line"></i> Submit a new ticket
    </button>
    <ul class="tickets-list">
      <li class="ticket-item">
        <div class="flex items-center gap-2 mb-3">
          <div class="profile">
            <img src="/dashboard/tickets/2.svg" alt="" />
          </div>
          <span class="ticket-title block">Testing tickets</span>
        </div>
        <span class="ticket-status">#82 • Closed</span>
        <p class="ticket-summary">I will try that...</p>
      </li>
    </ul>
  </aside>

  <!-- Main Content -->
  <main class="ticket-content">
    <header class="ticket-header justify-between items-center w-full">
      <div class="flex items-center gap-2">
        <div class="profile">
          <img src="/dashboard/tickets/2.svg" alt="" />
        </div>
        <div class="content">
          <h2>All tickets</h2>
          <p class="ticket-subtitle">All tickets</p>
        </div>
      </div>
      <button type="button" class="info-btn">
        <img src="/dashboard/tickets/3.svg" alt="" />
      </button>
    </header>

    <div class="ticket-details flex-wrap" *ngIf="!isEmpty">
      <!-- empty-content -->
      <div
        class="empty-content h-[765px] flex justify-center items-center flex-col gap-3"
      >
        <!-- Icon Placeholder -->
        <div class="icon">
          <img src="/dashboard/tickets/empty.png" alt="empty" />
        </div>

        <!-- Title -->
        <h2>Your Tickets</h2>

        <!-- Description -->
        <p class="description">
          Get in touch with our customer services team by creating a new ticket
          or managing an existing one.
        </p>

        <!-- Button -->
        <button
          class="submit-ticket-button"
          type="button"
          (click)="isEmpty = !isEmpty"
        >
          Submit a new ticket
        </button>
      </div>
    </div>

    <div class="ticket-details flex-wrap" *ngIf="isEmpty">

      <!-- Logo Section -->
      <div class="logo block w-full">
        <img src="/dashboard/tickets/4.svg" alt="Cladded Glass Logo" />
      </div>

      <p class="unsubscribe">
        To unsubscribe from this group and stop receiving emails from it, send
        an email to
        <a href="mailto:tickets+unsubscribe&#64;claddedglassbroadband.com"
          >tickets+unsubscribe&#64;claddedglassbroadband.com</a
        >.
      </p>

      <!-- Conversation -->
      <div class="conversation">
        <div class="message">
          <div class="sender items-center">
            <img
              src="/dashboard/tickets/5.svg"
              alt="User"
              class="sender-avatar"
            />
            <div>
              <strong>Warren</strong>
              <p class="sender-role">Cladded Glass representative • 11:39AM</p>
            </div>
          </div>
          <p class="message-content">
            <span>Hi Warren,</span><br /><br />
            Thank you for contacting us.<br />
            Please could you try and reboot your router (remember you may have
            multiple units around the house <br />
            if you have a based WiFi system).<br /><br />
            If you are still having an issue after this, please try restarting
            our equipment. It will <br />
            take about 5 minutes for everything to reconnect.<br />
            <br />
            Let us know if that solves the problem!<br />
            Thanks,<br />
            Cladded Glass
          </p>
        </div>

        <div class="reply">
          <div class="sender justify-start">
            <img
              src="/dashboard/tickets/6.svg"
              alt="User"
              class="sender-avatar"
            />
            <div>
              <strong>Warren</strong>
              <p class="sender-role">11:40AM</p>
              <p class="reply-content">I will try that</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="ticket-footer">
        <div class="info">
          <strong>warren&#64;claddedglass.com</strong>
          <p>
            Co-founder<br />
            Email:
            <a href="mailto:warren&#64;claddedglass.com"
              >warren&#64;claddedglass.com</a
            ><br />
            Business: 571.410.5811<br />
            Mobile: 317.500.1369<br />
            Web:
            <a href="http://www.claddedglass.com" target="_blank"
              >http://www.claddedglass.com</a
            >
          </p>
        </div>
      </div>
    </div>

    <!-- Bottom Message -->
    <div class="m-[20px]" *ngIf="isEmpty">
      <div class="bottom-message p-[20px] flex items-center">
        <div class="w-5/12">
          <img src="/dashboard/tickets/4.svg" alt="Cladded Glass Logo" />
          <p class="pt-1">
            This ticket is closed. Still need help? Contact support in a new
            message.
          </p>
        </div>
        <div class="w-7/12">
          <div class="info-box2 flex justify-between items-center">
            <div class="flex gap-2 items-center w-[60%]">
              <img src="/dashboard/tickets/3.svg" alt="" />
              <p>
                This ticket is closed. Still need help? Contact support in a new
                message.
              </p>
            </div>
            <button class="new-ticket-button">Submit a new ticket</button>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
